import React from "react"
import './appMenuCss.css'
//import Row from 'react-bootstrap/Row'
//import Col from 'react-bootstrap/Col'
//import Container from 'react-bootstrap/Container'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrophy, faHome, faEnvelope, faGlobe, faBars} from '@fortawesome/fontawesome-free-solid'
import { faHorse } from '@fortawesome/free-solid-svg-icons';
import {HashRouter as Router, Route, Routes, Link} from 'react-router-dom'
import Content from '../content/Content'
import Localisation  from "../pages/localisation/Localisation"
import Page_1  from '../pages/page_1/Page_1'
import Page_2  from '../pages/page_2/Page_2'
import Page_3  from '../pages/page_3/Page_3'
import Page_3_stallion_detail  from '../pages/page_3_stallion_detail/Page_3_stallion_detail'
import Contact from '../pages/contact/Contact'
import Page_3_alts  from '../pages/page_3_alts/Page_3_alts'
import Page_3_stallions  from '../pages/page_3_stallions/Page_3_stallions'
import Image from '../pages/image/Image'
import {useState} from "react"
import Header from '../header/Header';
import "../../locale/langue" ;
import { useTranslation } from 'react-i18next';
import i18next from '../../i18n';
import Juments from '../pages/juments/Juments';


function Menu(props){
    const [menuDisplayed, setMenuDisplayed]  = useState(true);
    //let lang = localStorage.getItem("langage");
    return(
        
        <Router>
            <main>
                {/*
                <Container fluid  className="menuDivId">
                    <Row >
                        <Col  className='menuItemDiv'>&nbsp; &nbsp;  <Link to="/" style={{textDecoration:'none', color:'white'}}> <FontAwesomeIcon icon={faHome}  /> Accueil</Link></Col>
                        <Col  className='menuItemDiv'>&nbsp; &nbsp; <Link to="/localisation" style={{textDecoration:'none', color:'white'}}><FontAwesomeIcon icon={faGlobe} /> Localisation</Link> </Col>
                        <Col  className='menuItemDiv'>&nbsp; &nbsp; <Link to="/evaluation" style={{textDecoration:'none', color:'white'}}><FontAwesomeIcon icon={faCommentDots} /> Evaluations</Link></Col>
                        <Col  className='menuItemDiv'>&nbsp; &nbsp; <Link to="/contact" style={{textDecoration:'none', color:'white'}}><FontAwesomeIcon icon={faEnvelope} /> Contact</Link></Col>
                        
                    </Row>
                </Container>

                */}

<Header></Header>

                <div  className="menuDivId">

                        {menuDisplayed? 
                        <div className='divMenuIconBlack divMenuIconResp'> <span className="float-right text-white fw-bold">Menu</span><span id="hiddingMenuDivForMenu" onClick={()=> setMenuDisplayed(!menuDisplayed)}><b><FontAwesomeIcon icon={faBars}  aria-hidden="true" /> &nbsp;</b></span></div> 
                        : <div className='divMenuIconGrey divMenuIconResp'> <span id="hiddingMenuDivForMenu" onClick={()=> setMenuDisplayed(!menuDisplayed)}><b><FontAwesomeIcon icon={faBars}  aria-hidden="true" /> &nbsp;</b></span></div> }
                        
                        {menuDisplayed? <MenuItems /> : null }
                    
                </div>

                <Routes>   
                    <Route path="/" element={<Content />}></Route>  
                    <Route path="/page1"  element={<Page_1 />}></Route>
                    <Route path="/page3"  element={<Page_3 />}></Route>
                    <Route path="/localisation" element={<Localisation/>}></Route>
                    <Route path="/page2" element={<Page_2 />}></Route>    
                    <Route path="/page3/image/:id/:backPage" element={<Image />}></Route>
                    <Route path="/page3_alts" element={<Page_3_alts />}></Route>
                    <Route path="/page3_stallions" element={<Page_3_stallions />}></Route>
                    <Route path="/page3_stallions/stallionDetail/:id" element={<Page_3_stallion_detail />}></Route>
                    <Route path="/page3_alts/image/:id/:backPage" element={<Image />}></Route>
                    <Route path="/contact" element={<Contact />}></Route>
                    <Route path="/juments" element={<Juments />}></Route>
                    <Route path="/juments/image/:id/:backPage" element={<Image />}></Route>
                </Routes> 
            </main>
        </Router>
    );
}



 function MenuItems(){
    //alert(props.langage)
    const { t } = useTranslation();

    return (
    <div>
        <div  className='menuItemDiv menuItemDivResp1 margeMenu'>&nbsp; &nbsp; <Link to="/" style={{textDecoration:'none', color:'black'}}> <FontAwesomeIcon icon={faHome}  /></Link></div>
        <div  className='menuItemDiv menuItemDivResp1'>&nbsp; &nbsp; <Link to="/contact" style={{textDecoration:'none', color:'black'}}><FontAwesomeIcon icon={faEnvelope} /></Link></div>
        
        <div  className='menuItemDiv menuItemDivResp2'>&nbsp; &nbsp; <Link to="/page3_stallions" style={{textDecoration:'none', color:'black'}}><FontAwesomeIcon icon={faHorse} /> {t('stallions')}
        </Link></div>
        <div  className='menuItemDiv menuItemDivResp2'>&nbsp; &nbsp; <Link to="/page3_alts" style={{textDecoration:'none', color:'black'}}><FontAwesomeIcon icon={faHorse} /> {t('products')}</Link></div>
        
        <div  className='menuItemDiv menuItemDivResp2'>&nbsp; &nbsp; <Link to="/page3" style={{textDecoration:'none', color:'black'}}><FontAwesomeIcon icon={faHorse} /> {t('champions')}</Link></div>

        <div  className='menuItemDiv menuItemDivResp2'>&nbsp; &nbsp; <Link to="/juments" style={{textDecoration:'none', color:'black'}}><FontAwesomeIcon icon={faHorse} /> {t('mares')}</Link></div>
        {/*<div  className='menuItemDiv menuItemDivResp1'>&nbsp; &nbsp; <Link to="/page1" style={{textDecoration:'none', color:'black'}}><FontAwesomeIcon icon={faTrophy} /></Link></div>*/}
        {/*<div  className='menuItemDiv menuItemDivResp1'>&nbsp; &nbsp; <Link to="/localisation" style={{textDecoration:'none', color:'black'}}><FontAwesomeIcon icon={faGlobe} /></Link> </div>*/}
    </div>                   
)
 }



export default Menu